<button class="jk-button-small" (click)="gotoDetail()">
  <mat-icon name="list"></mat-icon>
</button>
<button class="jk-button-small" (click)="doUIEdit()">
  <mat-icon slot="start" name="create"></mat-icon>
</button>
<button class="jk-button-small" (click)="doUIDelete()">
  <mat-icon name="trash"></mat-icon>
</button>
